export class ContactUsModel {
    constructor() { }
    public Name: string;
    public Email: string;
    public Subject: string;
    public Message: string;
  }